import FieldFlags from './FieldFlags';

export default FieldFlags;